import { modifier } from 'ember-modifier';
import { watchDocumentVisibility } from 'client-portal/utils/document-visibility';

/**
 * Invokes `onVisible` when the document becomes visible.
 * Only attaches in the browser (modifier setup does not run in FastBoot).
 *
 * Usage: <div hidden {{on-document-visibility this.onDocumentVisible}}></div>
 */
export default modifier(function onDocumentVisibility(_element, [onVisible]) {
  return watchDocumentVisibility(onVisible);
});
